import React, { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const ContactUs = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("ErrorReturn", "contact/error_return_lang");
  }, [language]);
  const LANGUAGE = componentLanguageData.ErrorReturn || { Main: {} };

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    phone: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, subject, message, phone } = formData;
    const data = { subject, message, email, name, phone, language };

    try {
      const response = await fetch('/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      if (response.ok) {
        alert(result.success || 'Thank you for contacting us. We will get back to you as soon as possible.');
      } else {
        alert(result.error || 'An error occurred. Please try again later!');
      }
    } catch (error) {
      console.error('發生錯誤:', error);
      alert('An error occurred. Please try again later!');
    }
  };

  return (
    <div
      className="container-fluid py-5 wow fadeInUp"
      data-wow-delay="0.1s"
      style={{ visibility: 'visible', animationDelay: '0.1s', animationName: 'fadeInUp' }}
      id="contact"
    >
      <div className="container py-5">
        <div
          className="section-title text-center position-relative pb-3 mb-5 mx-auto"
          style={{ maxWidth: '1000px' }}
        >
          <h5 className="fw-bold text-primary text-uppercase">{LANGUAGE.Main.Content1}</h5>
          <h1 className="mb-0">{LANGUAGE.Main.Content2}</h1>
        </div>
        <div className="row g-5 mb-5">
          <div className="col-lg-6">
            <div
              className="d-flex align-items-center wow fadeIn"
              data-wow-delay="0.4s"
            >
              <div
                className="bg-primary d-flex align-items-center justify-content-center rounded"
                style={{ width: '60px', height: '60px' }}
              >
                <i className="fa fa-envelope-open text-white"></i>
              </div>
              <div className="ps-4">
                <h5 className="mb-2">{LANGUAGE.Main.Content5}</h5>
                <h4 className="text-primary mb-0">{LANGUAGE.Main.Content6}</h4>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div
              className="d-flex align-items-center wow fadeIn"
              data-wow-delay="0.8s"
            >
              <div
                className="bg-primary d-flex align-items-center justify-content-center rounded"
                style={{ width: '60px', height: '60px' }}
              >
                <i className="fa fa-lightbulb  text-white"></i>
              </div>
              <div className="ps-4">
                <h5 className="mb-2">{LANGUAGE.Main.Content7}</h5>
                <h4 className="text-primary mb-0">{LANGUAGE.Main.Content8}</h4>
              </div>
            </div>
          </div>
        </div>
        <div className="row g-5">
          <div className="col-lg-6 wow slideInUp" data-wow-delay="0.3s">
            <form onSubmit={handleSubmit}>
              <div className="row g-3">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control border-0 bg-light px-4"
                    placeholder={LANGUAGE.Main.Content9}
                    name="name"
                    style={{ height: '55px' }}
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="phone"
                    className="form-control border-0 bg-light px-4"
                    placeholder={LANGUAGE.Main.Content14}
                    name="phone"
                    style={{ height: '55px' }}
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-12">
                  <input
                    type="email"
                    className="form-control border-0 bg-light px-4"
                    placeholder={LANGUAGE.Main.Content10}
                    name="email"
                    style={{ height: '55px' }}
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-12">
                  <input
                    type="text"
                    className="form-control border-0 bg-light px-4"
                    placeholder={LANGUAGE.Main.Content11}
                    name="subject"
                    style={{ height: '55px' }}
                    value={formData.subject}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-12">
                  <textarea
                    className="form-control border-0 bg-light px-4 py-3"
                    rows="4"
                    placeholder={LANGUAGE.Main.Content12}
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </div>
                <div className="col-12">
                  <button className="btn btn-primary w-100 py-3" type="submit">
                    {LANGUAGE.Main.Content13}
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
            <h1 className="display-6 mb-4">{LANGUAGE.Main.Content15}</h1>
            <p>{LANGUAGE.Main.Content16}</p>
            <p className="mb-4">{LANGUAGE.Main.Content17}</p>

            <div className="d-flex align-items-start wow fadeIn" data-wow-delay="0.3s">
              <div className="icon-box-primary">
                <i className="bi bi-lightbulb text-dark fs-1"></i>
              </div>
              <div className="ms-3">
                <h5>{LANGUAGE.Main.Content18}</h5>
                <span>{LANGUAGE.Main.Content19}</span>
              </div>
            </div>

            <hr />

            <div className="d-flex align-items-start wow fadeIn" data-wow-delay="0.4s">
              <div className="icon-box-primary">
                <i className="bi bi-clock text-dark fs-1"></i>
              </div>
              <div className="ms-3">
                <h5>{LANGUAGE.Main.Content20}</h5>
                <span>{LANGUAGE.Main.Content21}</span>
              </div>
            </div>

            <hr />

            <div className="d-flex align-items-start wow fadeIn" data-wow-delay="0.4s">
              <div className="icon-box-primary">
                <i className="bi bi-exclamation-triangle text-dark fs-1"></i>
              </div>
              <div className="ms-3">
                <h5>{LANGUAGE.Main.Content22}</h5>
                <span>{LANGUAGE.Main.Content23}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
